(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-custom"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const footer = document.currentScript.closest('.footer-custom') || document.querySelector('.footer-custom');
    if (!footer) return;

    const headings = footer.querySelectorAll('.footer-column__heading--collapsible');
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const applyAccordionState = () => {
      headings.forEach((heading) => {
        const column = heading.closest('.footer-column');
        const menu = column ? column.querySelector('.footer-column__menu') : null;
        if (!column || !menu) return;

        const enableAccordion = mobileQuery.matches;
        column.classList.toggle('is-accordion-enabled', enableAccordion);

        if (enableAccordion) {
          // Initialise bindings once
          if (!heading.dataset.accordionBound) {
            const toggle = () => {
              const isOpen = column.classList.toggle('is-open');
              heading.setAttribute('aria-expanded', String(isOpen));
              menu.style.display = isOpen ? 'flex' : 'none';
            };

            heading.setAttribute('tabindex', '0');
            heading.setAttribute('aria-expanded', 'false');
            heading.addEventListener('click', toggle);
            heading.addEventListener('keydown', (event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                toggle();
              }
            });
            heading.dataset.accordionBound = 'true';
          }

          const isOpen = column.classList.contains('is-open');
          menu.style.display = isOpen ? 'flex' : 'none';
          heading.setAttribute('aria-expanded', String(isOpen));
        } else {
          // Reset to desktop defaults
          column.classList.remove('is-open');
          heading.removeAttribute('tabindex');
          heading.removeAttribute('aria-expanded');
          menu.style.display = '';
        }
      });
    };

    mobileQuery.addEventListener('change', applyAccordionState);
    applyAccordionState();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
